import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import FixedFeeHeaderItemsList from "./FixedHeaderItemsList";
import EditFeeHeaderItems from "./EditFeeHeaderItems";
import { toast } from "react-toastify";
import { addFeeHeaderItemsAPI } from "services/fixedfeeService";

const FixedHeaderItems = ({ item }) => {
  const [isFormOpen, setIsFormOpen] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [refreshTrigger, setRefreshTrigger] = React.useState(0);

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      const vatValue = formData.netAmount * (formData?.vatCode?.rate / 100);
      const res = await addFeeHeaderItemsAPI(item.fixedFeeHeaderID, [
        {
          ...formData,
          vatCode: formData?.vatCode?.vatCodeId,
          vatValue,
          vatRate: formData?.vatCode?.rate,
        },
      ]);

      if (res.status === 200) {
        toast.success("Item added successfully");
        setIsFormOpen(false);
        setRefreshTrigger(prev => prev + 1); // Trigger refresh of the list
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-100 d-flex flex-column align-items-end">
      <div className="float-end">
        <Button className="common-btn m-3" onClick={() => setIsFormOpen(true)}>
          Add Item
        </Button>
      </div>
      <FixedFeeHeaderItemsList item={item} refreshTrigger={refreshTrigger} />
      {isFormOpen && (
        <EditFeeHeaderItems
          cancelEdit={() => setIsFormOpen(false)}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default FixedHeaderItems;
